module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_2010-f29fb7876938369639ff5f346b65aa0b.jpg";